import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-164060b1")

_pushScopeId("data-v-164060b1")
const _hoisted_1 = { class: "find-password-box" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 验证身份 ", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 设置新密码 ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "top-item-content" }, " 完成 ", -1)
const _hoisted_8 = { class: "content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_verification_1 = _resolveComponent("verification-1")
  const _component_verification_2 = _resolveComponent("verification-2")
  const _component_change_password = _resolveComponent("change-password")
  const _component_complete = _resolveComponent("complete")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["top-item", { active: _ctx.flag1 }]
      }, [
        _hoisted_3
      ], 2),
      _hoisted_4,
      _createVNode("div", {
        class: ["top-item", { active: _ctx.flag2 }]
      }, [
        _hoisted_5
      ], 2),
      _hoisted_6,
      _createVNode("div", {
        class: ["top-item", { active: _ctx.flag3 }]
      }, [
        _hoisted_7
      ], 2)
    ]),
    _createVNode("div", _hoisted_8, [
      (_ctx.verificating1)
        ? (_openBlock(), _createBlock(_component_verification_1, {
            key: 0,
            onNext1: _ctx.next1,
            phoneNumber: _ctx.phoneNumber,
            "onUpdate:phoneNumber": _cache[1] || (_cache[1] = ($event: any) => (_ctx.phoneNumber = $event))
          }, null, 8, ["onNext1", "phoneNumber"]))
        : (_ctx.verificating2)
          ? (_openBlock(), _createBlock(_component_verification_2, {
              key: 1,
              onNext2: _ctx.next2,
              phoneNumber: _ctx.phoneNumber,
              "onUpdate:phoneNumber": _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneNumber = $event))
            }, null, 8, ["onNext2", "phoneNumber"]))
          : (_ctx.changePassword)
            ? (_openBlock(), _createBlock(_component_change_password, {
                key: 2,
                onConfirmChange: _ctx.confirmChange,
                phoneNumber: _ctx.phoneNumber,
                "onUpdate:phoneNumber": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phoneNumber = $event))
              }, null, 8, ["onConfirmChange", "phoneNumber"]))
            : (_openBlock(), _createBlock(_component_complete, { key: 3 }))
    ])
  ]))
})